// extracted by mini-css-extract-plugin
module.exports = {"dialog":"DeleteApiKeyModal_dialog__3o2Nq"};